export default __webpack_public_path__ + "2c56b0ce65852b91f7846f3e89dfc60f.png";